export default "__VITE_ASSET__4fb2a73d__"